import { type PropsWithChildren } from 'react'
import { Stack } from '@mui/material'

type Props = PropsWithChildren

export const ModalFooter = ({ children }: Props) => (
  <Stack
    className="DhlModal-footer"
    sx={{
      display: 'flex',
      flexFlow: 'row wrap',
    }}
  >
    {children}
  </Stack>
)
